import styled from "styled-components";

export const RoundedBlock = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "personalizedRadius",
})<{ personalizedRadius?: boolean }>`
	${({ theme }) => theme.containerStyles.roundedBlockStyle};
	${({ personalizedRadius }) => (personalizedRadius ? "border-radius: 3px !important" : undefined)};
`;
